import { IPaymentDictionaryStore } from '../index'

export default function(
  store: IPaymentDictionaryStore,
): IPaymentDictionaryStore {
  return {
    ...store,
    request: {
      ...store.request,
      errMessage: '',
      isLoading: true,
    },
  }
}
